import { ChangeDetectionStrategy, Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ITask, ITaskParameter } from '@fi-shared/fi-task-shared/fi-task-shared';
import { ObjectTypes, SideListOptionType } from '@fi-shared/types';
import { ILoadDataArgs } from '@fi-shared/fi-items-list/fi-data-source-base.directive';
import { IItemsListDataFetchResult } from '@fi-shared/fi-items-list/fi-items-list';
import { IChecklist2Parameter } from '@fi-shared/checklist/checklist-v2';
import { FiTaskSharedService } from '@fi-shared/fi-task-shared/fi-task-shared.service';
import { FiTasksViewMode } from '@fi-shared/fi-task-shared/fi-task-enums';
import { FiTaskHelperService } from '@fi-shared/fi-task-shared/fi-task-helper.service';
import { FiRemoteStateFullDataSource } from '@fi-shared/fi-items-list/fi-remote-state-full-data-source';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { FiTaskStatusType } from '@fi-app/task-v2/fi-task-v2-enums';

@Component({
    selector: 'fi-task-list',
    template: `
        <div class="fi-task-list-wrapper" (fiWhenScrolled)="onScrollToBottom()">
          @for (task of items$ | async; track task) {
            <fi-task-list-item [task]="task"> </fi-task-list-item>
          }
        </div>
        `,
    styleUrls: ['./task-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-list' },
    standalone: false,
})
export class TaskListComponent extends FiRemoteStateFullDataSource<ITask> implements OnInit {
    @Input({ required: true }) tasksViewMode: FiTasksViewMode;
    @Input({ required: true }) taskListFilterType: SideListOptionType;

    defaultSortColumnName = 'Deadline';
    defaultSortDirection = false;
    itemsListType: FiItemsListType.TaskList;
    objectType: ObjectTypes.Task;

    constructor(
        injector: Injector,
        private fiTaskService: FiTaskSharedService,
        private taskHelperService: FiTaskHelperService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.reloadData();
    }

    loadListDataFn(loadArgs: ILoadDataArgs) {
        return new Promise<IItemsListDataFetchResult<ITask>>((resolve, reject) => {
            const parameter = this.getItemsListParameter(loadArgs) as ITaskParameter;
            this.fiTaskService.getTasksListData(parameter).then((data) => {
                resolve(data);
            }, reject);
        });
    }

    protected getItemsListParameter(loadArgs: ILoadDataArgs): IChecklist2Parameter {
        const parameter = super.getItemsListParameter(loadArgs) as ITaskParameter;
        parameter.SelectedSort = {
            ColumnName: this.defaultSortColumnName,
            SortDirection: this.defaultSortDirection,
        };
        this.taskHelperService.updateTaskParameter(parameter, {
            filterType: this.taskListFilterType,
            isArchived: false,
            isCompleted: this.taskHelperService.getIsCompletedFilterByViewMode(this.tasksViewMode),
        });
        // don't fetch cancelled tasks
        parameter.TaskStatuses = [FiTaskStatusType.NotStarted, FiTaskStatusType.InProcess, FiTaskStatusType.Completed];
        return parameter;
    }
}
